module.exports = __webpack_public_path__ + "static/media/user.4b508f06.jpg";